import { useEffect } from "react";
import { useTenantSettings } from "@/hooks/useTenantSettings";

/**
 * Applies tenant branding (primary color) as CSS custom properties in real-time.
 * Uses HSL format to seamlessly integrate with Tailwind's color system.
 */
export function useTenantBranding() {
  const { getSetting, isLoading } = useTenantSettings();

  useEffect(() => {
    if (isLoading) return;

    const primaryColor = getSetting("brand_primary_color", "");
    
    if (primaryColor) {
      // Expects HSL values like "222 47% 31%" (without hsl() wrapper)
      document.documentElement.style.setProperty("--primary", primaryColor);
      
      // Also update sidebar-primary to keep sidebar in sync
      document.documentElement.style.setProperty("--sidebar-primary", primaryColor);
    }

    return () => {
      // Cleanup: remove overrides so default theme returns
      document.documentElement.style.removeProperty("--primary");
      document.documentElement.style.removeProperty("--sidebar-primary");
    };
  }, [isLoading, getSetting]);
}
